import { render, staticRenderFns } from "./WebApp.vue?vue&type=template&id=00b7d3ab&"
import script from "./WebApp.vue?vue&type=script&lang=js&"
export * from "./WebApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports